import React, { useEffect, useState } from "react";
import "../../../assets/css/main.css";
import "../../../assets/vendor/bootstrap-icons/bootstrap-icons.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Header from "../header/header.jsx";
import Header1 from "../header/header1.jsx";
import Header3 from "../header/header3.jsx";
import Footer from "../footer/footer.jsx";
import Domaine from "../domaine/domaine.jsx";
import Footer1 from "../footer/footer1.jsx";



const Accueil = () => {

 // Initialiser AOS pour les animations
 useEffect(() => {
  AOS.init({ offset: 50, duration: 400, delay: 450 });
}, []);
  return (
    <>
      <div>
       
        <Header />

        <Header1 />
   {/* <Header2 /> */}
        <Header3 />

       
        <Domaine />

        <Footer1 />
        <Footer />

      </div>
    </>
  );
};

export default Accueil;
